/*
©2018 EdgeVerve Systems Limited (a fully owned Infosys subsidiary),
Bangalore, India. All Rights Reserved.
*/
/*
    TODO: Update documentation
    TODO: If the current and target pages are same, don't aplly loader 
	
	This element takes the reponsibilty of redirecting within the application. 
	Since this is an application level utility, this element should be included only onces in an application (programmers resonsibilty)
	Also that the "id" attribute must be set to "customNavigation" for proper functioning of the element
	But the element does not have the responsibity of knowing wheather the target location exists or not (programmers respponsiibilty).
	Logic: 
		Script registers a Event Listener named "customNavigation". 
		The programmer must fire this event via a script with following attributes in detail object:
			'gotoLocation': The url location to redirect to (mandatory)
			"forwardingData": This data will be accessable on that page(after redirect), under window.navForwardingData (optional)
		NOTE: It is a good practice that programmer deletes "window.navForwardingData" once it has been utilized
		
		If the user is not logged in, prompt the user for login and redirect after login. // TODO
		For the login flow, the prompt message is a mandatory input from the user 		  // TODO
		If the prompt message is not provided the event will be ingnored
	How to use (example):
	
		var event = new CustomEvent('customNavigation',  {'detail': {
			'gotoLocation': "/counterpartyTransfer"
			'forwardingData' : {
				"transferType": "PAYEEXFER",
				"id": "AC_002",
				"amount": "100"
			}
		}});
		window.dispatchEvent(event);
	
	in the above example, the forwardingData is being utilized by the target page i.e. "/counterpartyTransfer"
*/

import {html,Polymer} from '@polymer/polymer/polymer-legacy.js';

const template=html`
	<style include="app-styles">
		paper-material.round {
			border-radius: 50%;
			height: 34px;
			width: 36px;
		}

		paper-spinner.size {
			height: 30px;
			width: 30px;
		}

		.icon {
			padding: 0px;
			margin-top: -10px;
			width: 25px;
			height: 25px;
		}
	</style>
	
		<paper-dialog id="customNavigationLoginPrompt">
			<paper-card class="list-card">
				<div class="card-content">
					<div class="main-actions">
						<h5 style="color:grey">
							<!--TODO: add literals-->
							{{notloggedinprompt}}
						</h5>
						<paper-button id="loginPrompt" class="primary" dialog-confirm on-tap="proceedToLogin">
							<oe-i18n-msg msgid="b_Proceed "></oe-i18n-msg>Proceed
						</paper-button>
					</div>
				</div>
			</paper-card>
		</paper-dialog>
		<paper-dialog id="customNavigationRedirectPrompt">
			<paper-card class="list-card">
				<div class="card-content">
					<div class="main-actions">
						<h5 style="color:grey">
							<!--TODO: add literals-->
							{{redirectPrompt}}
						</h5>
						<paper-button raised id="redirectPromptIgnore" class="primary" dialog-confirm on-tap="_ignore">
							<oe-i18n-msg msgid="b_Later"></oe-i18n-msg>Ignore
						</paper-button>
						<paper-button id="redirectPromptAction" class="primary" dialog-confirm on-tap="_takeAction">
							<oe-i18n-msg msgid="b_Proceed "></oe-i18n-msg>Proceed
						</paper-button>
					</div>
				</div>
			</paper-card>
		</paper-dialog>
		<paper-dialog id="spinnerCardNav" modal>
			<div id="spinnerDialog">{{loaderMessage}}</div>
			<oe-hbox class="center-justified layout">
				<paper-spinner id="navigationSpinner"></paper-spinner>
			</oe-hbox>
		</paper-dialog>
	`
	
		Polymer({
			is: 'custom-navigation',
			_template:template,
			properties: {
				url: {
					type: String,
					value: "",
					notify: true
				},
				notloggedinprompt: {
					type: String,
					value: ""
				},
				redirectPrompt: {
					type: String,
					value: ""
				},
				forwardingstates: {
					type: Object,
					value: {}
				},
				loaderMessage: {
					type: String,
					value: ""
				},
				loaderFlag: {
					type: Boolean,
					value: false
				}
			},
			attached: function () {
				window.evaluateUrl();
			},
			proceedToLogin: function () {
				// set context, that can be forwarded from ev-login.html
				window.forwardingStates = this.forwardingstates;
				window.redirectUrl = this.url;
				window.activeRedirectLoader = true;
				// TODO: if and when the use case comes, to the required to redirect/pop-up the login page

				// close the login prompt
				//this.$.customNavigationLoginPrompt.close();
			},
			_ignore: function () {
				this.$.customNavigationRedirectPrompt.close();
			},
			_takeAction: function () {
				this.$.customNavigationRedirectPrompt.close();
				// oe_navigate_to
				window.oe_navigate_to("/" + this.url, this.forwardingstates);
				if (this.loaderFlag) {
					window.startRedirectLoader();
				}
			}
		});
		window.startRedirectLoader = function () {
			document.getElementById('spinnerCardNav').open();
		
			document.getElementById('navigationSpinner').active = true;
		},
			window.stopRedirectionLoader = function () {
				document.getElementById('spinnerCardNav').close();
				document.getElementById('navigationSpinner').active = false;
			};
		// Event Listener responsible for redirection
		window.addEventListener('customNavigation', function (event) {
			var loginRequired = false;
			var notLoggedInPromptReq = true;
			var notLoggedInPrompt = "";
			var promptRequired = false;
			var loaderRequired = false;

			var checkRedirectionInput = function (event) {
				// if no target location is specified
				if (!(event.detail !== 'undefined' && event.detail.gotoLocation !== 'undefined')) {
					// TODO: move to logger
					return [false, "customNavigation event was fired without target location, ignoing event"];
				}
				// set the url
				document.getElementById('customNavigation').url = event.detail.gotoLocation;
				return [true, ""];
			};

			var setRedirectionContext = function (event) {
				// check if login is required for the flow
				if (event.detail.loginRequiredFlag) {
					loginRequired = true;
					// check if login prompt required
					if (typeof event.detail.loginPromptReq != 'undefined') {
						notLoggedInPromptReq = event.detail.loginPromptReq;
					}
					// check if a prompt message was sent
					if (notLoggedInPromptReq) {
						if (event.detail.notLoggedInPrompt) {
							notLoggedInPrompt = event.detail.notLoggedInPrompt;
						}
						// default to a prompt message
						else {
							// TODO: need to move this to literals
							notLoggedInPrompt = "Login To Continue";
						}
					}
					// set the attribute for the login prompt
					document.getElementById('customNavigation').notloggedinprompt = notLoggedInPrompt;
				} else {
					// reset the attribute for the login prompt
					document.getElementById('customNavigation').notloggedinprompt = "";
				}

				// check if prompt is required for the flow, default to no prompt
				if (event.detail.promptMessage) {
					promptRequired = true;
					// set the attribute for the redirection prompt
					document.getElementById('customNavigation').redirectPrompt = event.detail.promptMessage;
				} else {
					// reset the attribute for the redirection prompt
					document.getElementById('customNavigation').redirectPrompt = "";
				}

				// check if there is any states that needs to be forwarded to the target page
				if (event.detail.forwardingState) {
					// set the attribute for the forwarding states
					document.getElementById('customNavigation').forwardingstates = event.detail.forwardingState;
				} else {
					// reset the attribute for the forwarding states
					document.getElementById('customNavigation').forwardingstates = {};
				}

				// check if there is any loader message
				if (event.detail.loaderMessage) {
					loaderRequired = true;
					document.getElementById('customNavigation').loaderFlag = true;
					document.getElementById('customNavigation').loaderMessage = event.detail.loaderMessage;
				} else {
					document.getElementById('customNavigation').loaderFlag = false;
					document.getElementById('customNavigation').loaderMessage = "";
				}
			};

			var promptForLogin = function () {
				// document.getElementById('customNavigationLoginPrompt').open();
				//document.getElementsByTagName("custom-navigation")[0].shadowRoot.querySelector("#loginPrompt").click();
				document.getElementById('customNavigation').shadowRoot.querySelector("#customNavigationLoginPrompt").querySelector("#loginPrompt").click();
			};

			var redirect = function () {
				if (promptRequired) {
				
					document.getElementById('customNavigationRedirectPrompt').open();
				} else {
					//document.getElementsByTagName("custom-navigation")[0].shadowRoot.querySelector("#redirectPromptAction").click();
					document.getElementById('customNavigation').shadowRoot.querySelector("#customNavigationRedirectPrompt").querySelector("#redirectPromptAction").click();
					if (loaderRequired) {
						window.startRedirectLoader();
					}
				}
			};

			var ret = checkRedirectionInput(event);
			if (!ret[0]) {
				// TODO: move to logger
			
				return;
			}

			var checkAsyncImportsLoaded = function () {
				var evLogin = document.getElementsByTagName("ev-login")[0];
				if (evLogin.asyncImportsLoaded === true) {
					evLogin.handleATMLocator();
				}
				else {
					setTimeout(function () {
						evLogin.handleATMLocator();
					}, 20000);
				}
			}

			setRedirectionContext(event);

			// if login is required
			if (loginRequired) {
				// check if the user is logged in
				if (clientStorage.get(storageType.session, "userId")) {
					// logged in user, redirect
					redirect(event);
				}
				// user not logged in, prompt for login
				else if (notLoggedInPromptReq) {
					promptForLogin(event);
				} else {
					document.getElementsByTagName("custom-navigation")[0].shadowRoot.querySelector("#loginPrompt").click();
					
				}
			}
			// else
			else {
				if (event.detail.gotoLocation === "atm-locator") {
					if (clientStorage.get(storageType.session, "userId")) {
						// logged in user, redirect
						redirect(event);
					}
					//user not logged in
					else {
						checkAsyncImportsLoaded();
					}
				}
				else {
					redirect(event);
				}
			}
		});

			